import { SearchResponseNodeOutput } from '@ariksa/inventory-core/api';

export const isResourceNode = (node: SearchResponseNodeOutput) => {
  return node.header === 'Resource';
};

export const isResourceTypeNode = (node: SearchResponseNodeOutput) => {
  return node.header === 'Resource Type';
};
